export function interpolateColor(hex1, hex2, t) {
  const rgb1 = hexToRgb(hex1);
  const rgb2 = hexToRgb(hex2);
  const r = Math.round(rgb1.r + (rgb2.r - rgb1.r) * t);
  const g = Math.round(rgb1.g + (rgb2.g - rgb1.g) * t);
  const b = Math.round(rgb1.b + (rgb2.b - rgb1.b) * t);
  return `rgb(${r},${g},${b})`;
}

export function hexToRgb(hex) {
  hex = hex.replace(/^#/, "");
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((x) => x + x)
      .join("");
  }
  const num = parseInt(hex, 16);
  return {
    r: (num >> 16) & 255,
    g: (num >> 8) & 255,
    b: num & 255,
  };
}

export function getTreemapColor(value, invert = false) {
    value = Math.round(value);

    if (invert) {
      value = 100 - value;
    }

    if (value <= 20) {
      return interpolateColor("#9BCB30", "#5ACB05", value / 20);
    }

    if (value >= 21 && value <= 27) {
      return "#B1D13A";
    }
    if (value > 27 && value <= 34) {
      return interpolateColor("#B1D13A", "#9BCB30", (value - 27) / (34 - 27));
    }

    if (value >= 35 && value <= 45) {
      return interpolateColor("#E7E153", "#FFB500", (value - 35) / (45 - 35));
    }

    if (value >= 46 && value <= 73) {
      return "#FAA503";
    }

    if (value >= 74 && value <= 100) {
      return interpolateColor("#FAA503", "#FA5A2F", (value - 74) / (100 - 74));
    }

    return "#e0e0e0";
  }
